export const META_TITLE = 'Влияние кризиса и самоизоляции на рынок недвижимости';
export const META_DESCRIPTION = 'Каждый день обновляем данные об изменении спроса, предложения и цен на жилье';
export const DEFAULT_IMAGE_PATH = 'https://cdn-p.cian.site/images/common/no_image_dummy.png';
